import React from 'react'
import { withUserStore } from '../../../contexts/UserStore'
import { Button, Input } from '@byscott-io/corebyscott'
import Lex from '../../Shared/Lex'

const AccountExport = ({ userStore }) => {
  const form = {}

  const exportAccount = () => {
    userStore.exportAccount(form.name?.value || 'test account', form.accountType?.value)
  }

  return (
    <div className="center margin-top cbs-scope">
      <table className="center p10">
        <tbody>
          <tr>
            <th className="text-right"><Lex term="time-offsets" /></th>
            <td><Input type="checkbox" innerRef={el => form.time_offsets = el} defaultValue={false} /><Lex
              term="change-time-to-offset"
            />
            </td>
          </tr>
          <tr>
            <th className="text-right" />
            <td><Button onClick={() => exportAccount()} color="success"><Lex term="export" /></Button></td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default withUserStore(AccountExport)
